import { styled } from "@mui/material"
import React from "react"
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom"

const CustomLink = styled(RouterLink)(({ theme }) => ({
  textDecoration: "none !important",
  "&:hover": {
    color: theme.palette.primary.main
  }
}))

const LinkBehavior = React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, "to"> & { href: RouterLinkProps["to"] }>(
  (props, ref) => {
    const { href, ...other } = props

    // Map href (MUI) -> to (react-router)
    return <CustomLink ref={ref} to={href} {...other} />
  }
)
export default LinkBehavior
